import React from 'react';
import PropTypes from 'prop-types';
import {
  Button as BaseButton,
  Hotkey,
  Hotkeys,
  HotkeysTarget,
  Icon,
  InputGroup,
  Intent,
  Menu,
  MenuItem,
} from '@blueprintjs/core';
import { Col, Row } from 'reactstrap';
import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { Popover2 } from '@blueprintjs/popover2';
import YearSelect from 'components/elements/select-year';
import LookuplistSelect from 'components/elements/select-lookuplist-items';
import styled from 'styled-components';
import { COLOR } from 'config';

const Button = styled(BaseButton)`
  font-size: 12px !important;
`;

const ButtonGroup = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

@HotkeysTarget
class SearchForm extends React.Component {
  static propTypes = {
    handelSearch: PropTypes.func,
    handelExport: PropTypes.func,
    handel: PropTypes.func,
  };
  renderHotkeys() {
    const { handleSearch } = this.props;
    return (
      <Hotkeys>
        <Hotkey
          allowInInput={true}
          combo='enter'
          label='Be awesome all the time'
          onKeyDown={handleSearch}
        />
      </Hotkeys>
    );
  }

  render() {
    const { form, toogleMap } = this.props;

    return (
      <div>
        <Row>
          <Col>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>Tìm kiếm</span>
              <Clearfix width={8} />
              <div style={{ flex: 1 }}>
                {form.getFieldDecorator('ProjectName')(
                  <InputGroup placeholder='Tên dự án' />
                )}
              </div>
              <Clearfix width={8} />
              <Icon
                icon={IconNames.SEARCH}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                onClick={this.props.handleSearch}
              />
            </div>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={3}>
            <LookuplistSelect
              label='Tên loài'
              lookupListId='SpiciesName'
              fieldForm={{ form, name: 'SpiciesName' }}
            />
          </Col>
          <Col xs={3}>
            <LookuplistSelect
              label='Mức độ bảo tồn'
              lookupListId='SpiciesType'
              fieldForm={{ form, name: 'SpiciesType' }}
            />
          </Col>
          <Col xs={3}>
            <YearSelect
              fieldForm={{
                form,
                name: 'ReportYear',
              }}
            />
          </Col>
          <ButtonGroup xs={3}>
            <Popover2
              placement='bottom'
              content={
                <Menu>
                  <MenuItem
                    onClick={() => this.props.handleExport('general')}
                    text='Báo cáo tổng quan'
                  />
                  <MenuItem
                    onClick={() => this.props.handleExport('detail')}
                    text='Báo cáo chi tiết'
                  />
                </Menu>
              }
            >
              <Button large icon='import' rightIcon='chevron-down'>
                Xuất dữ liệu
              </Button>
            </Popover2>
            <Button
              onClick={this.props.handleToogleMap}
              style={{ marginLeft: 16 }}
              large
              icon={!toogleMap ? 'map-marker' : 'page-layout'}
            >
              {toogleMap ? 'Xem danh sách' : 'Xem bản đồ'}
            </Button>
          </ButtonGroup>
        </Row>
      </div>
    );
  }
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityList/SearchForm/index.js